import { render, staticRenderFns } from "./VueHorizontal.vue?vue&type=template&id=6b5a1d2e&scoped=true"
import script from "./VueHorizontal.vue?vue&type=script&lang=js"
export * from "./VueHorizontal.vue?vue&type=script&lang=js"
import style0 from "./VueHorizontal.vue?vue&type=style&index=0&id=6b5a1d2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5a1d2e",
  null
  
)

export default component.exports